import PropTypes from 'prop-types';

import { Trans, useTranslation } from 'next-i18next';
import {
	Button,
	Card,
	Col,
	Stack,
	InfoCard,
	CheckBox,
	FormGroup,
	Password,
	Row,
} from 'components/ui';
import { Benutzerdaten } from 'VaxForm_02_Benutzerinformation/components/Benutzerdaten.js';
import { useSelector } from 'react-redux';

const Benutzerinformation = ({
	edit,
	hideCreateAccount,
	updateUser,
	formData,
	validation,
	integratedTitle,
}) => {
	const [t] = useTranslation();

	const toggleCreateAccount = () => {
		const newValue = !formData?.user?.createAccount;
		updateUser({
			createAccount: newValue,
		});
	};

	const user = useSelector((state) => state.settings.currentUser);

	return (
		<Row>
			<Col xs={12} md={4}>
				<Benutzerdaten
					updateUser={updateUser}
					formData={formData}
					validation={validation}
					integratedTitle={integratedTitle}
					edit={edit}
				/>
			</Col>
			{edit && user && user.email == formData.user?.email && (
				<Col xs={4}>
					<Trans i18nKey={'nutzerbereich.eintraege.bearbeiten.link_profil'}>
						Nutzerdaten können im <a href='/nutzerbereich/profil'>Profil</a>{' '}
						bearbeitet werden.
					</Trans>
				</Col>
			)}
			{!hideCreateAccount && (
				<>
					<Col xs={12} md={4}>
						<FormGroup className='mb-3' style={{ marginTop: '50px' }}>
							<Stack gap={3}>
								<CheckBox
									label={t(
										'nutzerbereich.registrieren.vetopedia_konto_erstellen'
									)}
									onChange={toggleCreateAccount}
									checked={formData?.user?.createAccount}
								/>
								{formData?.user?.createAccount && (
									<>
										<Password
											label={t('common.passwort')}
											value={formData.user.password}
											onChange={(e) => {
												updateUser({
													password: e.target.value,
												});
											}}
											isInvalid={validation['password']}
										/>
										<Password
											label={t('impfschaeden.erfassen.passwort_wiederholen')}
											value={formData?.user?.passwordRepeat}
											onChange={(e) => {
												updateUser({
													passwordRepeat: e.target.value,
												});
											}}
											isInvalid={validation['passwordRepeat']}
										/>
									</>
								)}
							</Stack>
						</FormGroup>
					</Col>
					<Col xs={12} md={4}>
						{!edit && (
							<InfoCard bg='light' style={{ width: '100%' }}>
								<Card.Body>
									<Card.Title>
										{t('impfschaeden.erfassen.bereits_ein_konto')}
									</Card.Title>
									<div>
										<Button
											variant='secondary'
											href={
												'/nutzerbereich/login?returnUrl=%2Fimpfschaden%2Ferfassen'
											}
										>
											{t('impfschaeden.erfassen.hier_anmelden')}
										</Button>
									</div>
								</Card.Body>
							</InfoCard>
						)}
					</Col>
				</>
			)}
			{/* <Col xs={12} md={4}></Col> */}
		</Row>
	);
};

Benutzerinformation.propTypes = {
	edit: PropTypes.bool,
	formData: PropTypes.object,
	anotherPerson: PropTypes.bool,
	hideCreateAccount: PropTypes.bool,
	updateUser: PropTypes.func,
	update: PropTypes.func,
	validation: PropTypes.object,
	integratedTitle: PropTypes.string,
};

export { Benutzerinformation };
